module.exports = __webpack_public_path__ + "img/Insurance-Slide.4c682f97.jpg";